class RecommendedGateway {
    constructor() {
        this.organizationID = new URLSearchParams(window.location.search).get('organizationID');

        this.enableRecommendedGateway();
    }
    enableRecommendedGateway(){
        const thisClass = this;
        let recommendedGatewayCheckbox = document.getElementById('recommended-gateway-checkbox');
        if(recommendedGatewayCheckbox){
            recommendedGatewayCheckbox.addEventListener('change', function () {
                Swal.fire({
                    html: `<span class="text-center text-primary">Are you sure you want to `+(this.checked ? 'enable' : 'disable')+` recommended Gateway?</span>`,
                    icon: "warning",
                    iconColor: "#FF5206",
                    buttonsStyling: false,
                    reverseButtons: true,
                    showCancelButton: true,
                    confirmButtonText: "Yes, "+(this.checked ? 'enable' : 'disable')+"!",
                    customClass: {
                        confirmButton: "btn btn-danger mt-0",
                        cancelButton: 'btn btn-light-primary mt-0',
                    },
                    showLoaderOnConfirm: true,
                    returnFocus: false,
                    preConfirm: () => {
                        return naja.makeRequest('GET', '/gateways?do=changeRecommendedGateway', {
                            'organizationID': thisClass.organizationID,
                            'enable': this.checked ? 1 : 0
                        }, {
                            history: false // Prevent URL changes in browser history
                        }).then((response) => {
                            if (response) {
                                return response;
                            }
                        });
                    },
                    allowOutsideClick: () => !Swal.isLoading(),
                    allowEscapeKey: () => !Swal.isLoading()
                }).then((result) => {
                    if (result.isConfirmed) {
                        toastr.success('Recommended gateway has been successfully '+(this.checked ? 'enabled' : 'disabled')+'!');
                    } else {
                        recommendedGatewayCheckbox.checked = !this.checked;
                    }
                });
            });
        }
    }
}
window.RecommendedGateway = RecommendedGateway;